import React from 'react';

import { zitadelSSOService } from 'web-shared/services/sso-auth-service/vendors/zitadel';

import SSOSignInCallbackPage from '../shared/SSOSignInCallbackPage';

const ZitadelCallbackPage = () => (
  <SSOSignInCallbackPage ssoService={zitadelSSOService} />
);

export default ZitadelCallbackPage;
